import { uppercaseAllFirstLetters } from "../../../utilities/uppercaseAllFirstLetters";
import { getFamilyGroups } from "../getFamilyGroups";
import { addToGroups } from "./addToGroups";
// TODO: align with the HTML function
export function loadDirectoryCSV(url) {
    console.time("scrape-csv-directory");
    const localStorageKey = "cp-families";
    const now = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    const storedDirectory = JSON.parse(window.localStorage.getItem(localStorageKey));
    if (storedDirectory &&
        // refresh every day
        storedDirectory.lastModified + oneDay > now.valueOf()) {
        console.timeEnd("scrape-csv-directory");
        return Promise.resolve(storedDirectory);
    }
    return new Promise((resolve) => {
        // handle url seperately for security reasons
        fetch(url)
            .then((response) => {
            if (!response.ok) {
                throw new Error("" + response.status);
            }
            return response.text();
        })
            .then((data) => {
            const families = {};
            // const regex = { newline: /\s+|.+/gim };
            const rows = data.trim().split(",\n");
            const members = [];
            const elders = [];
            const deacons = [];
            if (rows) {
                const memberProps = rows
                    .shift()
                    .replace(/^"|"$/g, "")
                    .split('","')
                    .map((prop) => prop
                    .toLowerCase()
                    .trim()
                    // TODO: come back and fix these ignores...
                    // eslint-disable-next-line no-useless-escape
                    .replace(/[\s\.\/,]+/g, "-")
                    // TODO: come back and fix these ignores...
                    // eslint-disable-next-line no-useless-escape
                    .replace(/-?[\(\[].+|\s+[\)\]]|-?$/g, ""));
                rows.forEach((memberStr) => {
                    var _a, _b, _c;
                    const member = {};
                    member.groups = [];
                    memberStr = memberStr.replace(/^"|"$/g, "");
                    if (memberStr) {
                        const memberVal = memberStr
                            .replace(/^"|"$/g, "")
                            .split('","');
                        if (memberProps.length && memberVal.length) {
                            for (let i = 0, l = memberProps.length; i < l; i++) {
                                const prop = memberProps[i];
                                const value = memberVal[i];
                                // some specific data transforms to help align with common data structure
                                if (prop.indexOf("group-") === 0) {
                                    const name = uppercaseAllFirstLetters(prop
                                        .replace("group-", "")
                                        .replaceAll("-", " "));
                                    addToGroups(name, value, member.groups);
                                }
                                else if (prop.indexOf("custom-") === 0) {
                                    const propName = prop.replace("custom-", "");
                                    member[propName] = value;
                                }
                                else if (prop === "cell-phone-number") {
                                    member.cell = value;
                                }
                                else if (prop === "email-address") {
                                    member.email = value;
                                }
                                else if (prop === "non-member") {
                                    member["non-member"] =
                                        value;
                                }
                                else if (prop !== "groups") {
                                    // TODO: might consider removing this unecessary conditional
                                    member[prop] = value;
                                }
                            }
                            if (member["family-name"]) {
                                const familyName = member["family-name"];
                                let family = families[familyName];
                                if (!family) {
                                    family = {
                                        "family-name": familyName,
                                        members: [],
                                    };
                                    families[familyName] = family;
                                }
                                members.push(member);
                                family.members.push(member);
                                // for some reason congregate has the photos here backwards
                                (_a = family["family-photo-url"]) !== null && _a !== void 0 ? _a : (family["family-photo-url"] = member["individual-photo-url"] ||
                                    member["family-photo-url"]);
                                // for some reason congregate has the photos here backwards
                                member["individual-photo-url"] =
                                    member["family-photo-url"];
                                family["last-name"] =
                                    family["last-name"] ||
                                        member["last-name"];
                                family["zip-code"] =
                                    family["zip-code"] ||
                                        member["zip-code"];
                                family["membership-status"] =
                                    family["membership-status"] ||
                                        member["membership-status"];
                                family.address =
                                    family.address || member.address;
                                family.city = family.city || member.city;
                                family.state = family.state || member.state;
                                family["family-id"] =
                                    ((_c = (_b = family["family-photo-url"]) === null || _b === void 0 ? void 0 : _b.match(/\d+/)) === null || _c === void 0 ? void 0 : _c[0]) || "";
                                member["family-id"] = family["family-id"];
                                family.groups = getFamilyGroups(member.groups, family.groups);
                            }
                            // deacons
                            if (member.groups.indexOf("Deacons") > -1 &&
                                member.groups.indexOf("Elders") === -1) {
                                deacons.push(member);
                            }
                            // elders
                            if (member.groups.indexOf("Elders") > -1) {
                                elders.push(member);
                            }
                        }
                        return member;
                    }
                });
            }
            const cpFamilies = {
                lastModified: now.valueOf(),
                members,
                families,
                elders,
                deacons,
            };
            window.localStorage.setItem(localStorageKey, JSON.stringify(cpFamilies));
            console.timeEnd("scrape-csv-directory");
            return resolve(cpFamilies);
        });
    });
}
